






















































import Vue from "vue";
import moment from "moment";

// Vuex
import { RootState } from "@/store";
import { mapActions, mapState } from "vuex";
import * as a_ecr from "@/store/modules/FitnessStatisticsModule/actions";

// Vue Components
import EcrUploadFileModal from "./EcrUploadFileModal.vue";
import EcrListModal from "./EcrListModal.vue";

export default Vue.extend({
    components: {
        EcrUploadFileModal,
        EcrListModal,
    },
    data() {
        return {
            showEcrUploadFileModal: false,
            showEcrListModal: false,
        };
    },
    computed: {
        ...mapState({
            ecrFileVersion: (state: RootState): string => state.fitnessStatistics.ecrFileVersion,
            ecrFileLastUpdate: (state: RootState): Date => state.fitnessStatistics.ecrFileLastUpdate,
        }),
    },
    methods: {
        moment,
        ...mapActions([a_ecr.GET_ECR_FILE_INFORMATIONS]),
    },
    mounted() {
        if (this.ecrFileVersion == null || this.ecrFileLastUpdate == null) this[a_ecr.GET_ECR_FILE_INFORMATIONS]();
    },
});
